class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab)));
    this.syncWidthToMedia();
  }

  // Match the product media/gallery column's actual rendered width AND
  // horizontal position instead of stretching full content width. Measuring
  // live (rather than replicating the product grid's column math in CSS)
  // keeps this correct regardless of the merchant's media position
  // (left/right)/equal-columns/sidebar-width settings, which change that
  // math at several breakpoints.
  syncWidthToMedia() {
    const media = document.querySelector('.product-information__media');
    if (!media) return;

    const apply = () => {
      // Reset first so this always measures from the natural (unshifted)
      // position - otherwise a previously-applied margin would be included
      // in ownRect and the offset would drift on repeated calls (resize,
      // ResizeObserver firing again, etc).
      this.style.marginInlineStart = '';
      const mediaRect = media.getBoundingClientRect();
      const ownRect = this.getBoundingClientRect();
      if (mediaRect.width === 0) {
        this.style.maxWidth = '';
        return;
      }
      this.style.maxWidth = `${mediaRect.width}px`;
      this.style.marginInlineStart = `${mediaRect.left - ownRect.left}px`;
    };

    apply();
    new ResizeObserver(apply).observe(media);
    window.addEventListener('resize', apply);
  }

  activate(tab) {
    const scrollTargetId = tab.getAttribute('data-tab-scroll-target');
    if (scrollTargetId) {
      const target = document.getElementById(scrollTargetId) ||
                     document.getElementById(scrollTargetId.replace(/^shopify-section-/, '')) ||
                     document.querySelector('.product-reviews') ||
                     document.getElementById('customer-reviews');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    const targetPanelId = tab.getAttribute('aria-controls');
    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.tabIndex = isActive ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== targetPanelId;
    });
  }
}

customElements.define('product-tabs', ProductTabs);
